import request from '@/utils/request'

export function get() {
  return request({
    url: '/settings',
    method: 'get'
  })
}

